import type { Account } from "Utils/types";

export const RECEIVE_EMPLOYER_DATA = "EmployerDashboard/RECEIVE_EMPLOYER_DATA";
export const UPDATE_MANAGE_EMPLOYEES_TAB = "EmployerDashboard/UPDATE_MANAGE_EMPLOYEES_TAB";
export const UPDATE_OFFER_COVERAGE_SUCCESS_MESSAGE = "EmployerDashboard/UPDATE_OFFER_COVERAGE_SUCCESS_MESSAGE";

export const receiveEmployerData = (response: Account) => ({
  type: RECEIVE_EMPLOYER_DATA,
  payload: response,
});

export const updateManageEmployeesTab = (tabName: string) => ({
  type: UPDATE_MANAGE_EMPLOYEES_TAB,
  payload: tabName,
});

export const updateOfferCoverageSuccessMessage = (message: string) => ({
  type: UPDATE_OFFER_COVERAGE_SUCCESS_MESSAGE,
  payload: message,
});
